export var cifPw = ["301 189", "<g fill='none'><path fill='#4AADD6' d='M.5.75h300v187.5H.5z'/><circle cx='131.75' cy='94.5' r='56.25' fill='#FFDE00'/></g>"];
